export default {
  computed: {
    isUAForm() {
      const brand = this?.$attrs?.brand || this?.brand
      return brand === 'URBANARROW'
    },
  },
}
